import { BullhornIcon } from './BullhornIcon';

/**
 * author: Google
 * id A5D2E199-03A1-4C23-9C63-954D63DEBEB4
 * name bullhorn
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bullhorn.svg
 * tags
 */
export const MegaphoneIcon = BullhornIcon;
export default MegaphoneIcon